module.exports = __webpack_public_path__ + "img/03n.a1cb48a6.png";